import { NgModule } from "@angular/core";
import { AuctionLayoutComponent } from "./auction-layout.component";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [AuctionLayoutComponent],
  imports: [CommonModule, RouterModule],
})
export class AuctionLayoutModule {}
